var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('intro'),_vm._v(" "),_c('prez'),_vm._v(" "),_c('known-for'),_vm._v(" "),_c('actions'),_vm._v(" "),_c('fuel'),_vm._v(" "),_c('politic'),_vm._v(" "),_c('clarification'),_vm._v(" "),_c('events'),_vm._v(" "),_c('sfs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }